// extracted by mini-css-extract-plugin
export default {"barChartWrapper":"Bar_barChartWrapper__99nxJ","barChartContent":"Bar_barChartContent__KEl9h","title":"Bar_title__UWZfR"};